export default __webpack_public_path__ + "static/media/1441.31eae6cd.png";